import { PackageDTO } from '@luminovo/http-client';
import { usePartPackages } from '../../../resources/part/partHandler';

export function useGenericPartPackage({ packageId }: { packageId: string | null }) {
    const { data: allPackages = [] } = usePartPackages('generic-part-creatable');
    const packageData: PackageDTO | null = allPackages.find((p) => p.id === packageId) ?? null;

    return packageData;
}
